import { faCircleCheck, faCircleXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type CellContext } from '@tanstack/react-table';
import { useIntl } from 'react-intl';

import { Badge } from 'src/registry/ui/Badge';
import { generalMessages } from 'src/registry/utils/messages';

export function CellBoolean<TData, TValue>({ getValue }: CellContext<TData, TValue>) {
    const value = getValue();
    const { formatMessage } = useIntl();
    return (
        <Badge theme={value ? 'green' : 'red'}>
            <FontAwesomeIcon icon={value ? faCircleCheck : faCircleXmark} />
            {formatMessage(value ? generalMessages.yes : generalMessages.no)}
        </Badge>
    );
}
